export const BACKEND_ERROR = {
  DATA_NOT_FOUND: "data not found",
};

export const BACKEND_ERROR_TRANSLATOIN_KEY: Record<string, string> = {
  "please use correct username/password": "page.login.error.wrong_credential",
  "name has reach max limit character": "error.backend.max_name_char",

  "unexpected error": "backend_error.unexpected_error",
  "bad request": "backend_error.bad_request",
  "missing authentication header":
    "backend_error.missing_authentication_header",
  "missing id user header": "backend_error.missing_id_user_header",
  "missing id corp header": "backend_error.missing_id_corp_header",
  "authorization token is invalid":
    "backend_error.authorization_token_is_invalid",
  "authorization token has expired":
    "backend_error.authorization_token_has_expired",
  "user cannot take this action": "backend_error.user_cannot_take_this_action",
  "extention file image not supported":
    "backend_error.extention_file_image_not_supported",
  "file image size is too big": "backend_error.file_image_size_is_too_big",
  "data not found": "backend_error.data_not_found",
  "profile picture cannot be empty":
    "backend_error.profile_picture_cannot_be_empty",
  "name cannot be empty": "backend_error.name_cannot_be_empty",
  "name cannot contain emoji": "backend_error.name_cannot_contain_emoji",
  "name only can contains alphanum with space":
    "backend_error.name_only_can_contains_alphanum_with_space",
  "country residence cannot be empty":
    "backend_error.country_residence_cannot_be_empty",
  "type cannot be empty": "backend_error.type_cannot_be_empty",
  "phone number and country code cannot be empty":
    "backend_error.phone_number_and_country_code_cannot_be_empty",
  "email cannot be empty": "backend_error.email_cannot_be_empty",
  "wrong email format": "backend_error.wrong_email_format",
  "establishment date cannot be empty or null":
    "backend_error.establishment_date_cannot_be_empty_or_null",
  "establishment date format must be yyyy-mm-dd":
    "backend_error.establishment_date_format_must_be_yyyy_mm_dd",
  "country residence reached limit max char":
    "backend_error.country_residence_reached_limit_max_char",
  "duplicate data": "backend_error.duplicate_data",
  "members data cannot be empty": "backend_error.members_data_cannot_be_empty",
  "nta number cannot be empty": "backend_error.nta_number_cannot_be_empty",
  "nta number length should be 13":
    "backend_error.nta_number_length_should_be_13",
  "id nta is not exists": "backend_error.id_nta_is_not_exists",
  "corporation name is not equal with jta":
    "backend_error.corporation_name_is_not_equal_with_jta",
  "request data contain invalid id member":
    "backend_error.request_data_contain_invalid_id_member",
  "id member cannot be empty": "backend_error.id_member_cannot_be_empty",
  "member type cannot be empty": "backend_error.member_type_cannot_be_empty",
  "invalid member type": "backend_error.invalid_member_type",
  "you are not member from this bu":
    "backend_error.you_are_not_member_from_this_bu",
  "one or more of the reference data is invalid":
    "backend_error.one_or_more_of_the_reference_data_is_invalid",
  "cannot publish this job due to incomplete condition":
    "backend_error.cannot_publish_this_job_due_to_incomplete_condition",
  "job already published": "backend_error.job_already_published",
  "invalid user type": "backend_error.invalid_user_type",
  "requested data contains invalid qualification":
    "backend_error.requested_data_contains_invalid_qualification",
  "stakeholder type is invalid": "backend_error.stakeholder_type_is_invalid",
  "stakeholder type is required": "backend_error.stakeholder_type_is_required",
  "last member is not allowed to leave":
    "backend_error.last_member_is_not_allowed_to_leave",
  "one or more of the reference keys is invalid, please check your ids validity":
    "backend_error.one_or_more_of_the_reference_keys_is_invalid_please_check_your_ids_validity",
  "business establishment cannot be empty":
    "backend_error.business_establishment_cannot_be_empty",
  "country has reach max limit character":
    "backend_error.country_has_reach_max_limit_character",
  "postal code has reach max limit character":
    "backend_error.postal_code_has_reach_max_limit_character",
  "address line 1 has reach max limit character":
    "backend_error.address_line_1_has_reach_max_limit_character",
  "address line 2 has reach max limit character":
    "backend_error.address_line_2_has_reach_max_limit_character",
  "city has reach max limit character":
    "backend_error.city_has_reach_max_limit_character",
  "country cannot contain emoji": "backend_error.country_cannot_contain_emoji",
  "postal code cannot contain emoji":
    "backend_error.postal_code_cannot_contain_emoji",
  "address line 1 cannot contain emoji":
    "backend_error.address_line_1_cannot_contain_emoji",
  "address line 2 cannot contain emoji":
    "backend_error.address_line_2_cannot_contain_emoji",
  "city cannot contain emoji": "backend_error.city_cannot_contain_emoji",
  "country cannot be empty": "backend_error.country_cannot_be_empty",
  "postal code cannot be empty": "backend_error.postal_code_cannot_be_empty",
  "address line 1 cannot be empty":
    "backend_error.address_line_1_cannot_be_empty",
  "city cannot be empty": "backend_error.city_cannot_be_empty",
  "prefecture cannot be empty": "backend_error.prefecture_cannot_be_empty",
  "prefecture cannot contain emoji":
    "backend_error.prefecture_cannot_contain_emoji",
  "address list cannot be empty": "backend_error.address_list_cannot_be_empty",
  "requested id cannot be empty": "backend_error.requested_id_cannot_be_empty",
  "field id cannot be empty": "backend_error.field_id_cannot_be_empty",
  "remaining slot must be not greater than total slot":
    "backend_error.remaining_slot_must_be_not_greater_than_total_slot",
  "invalid sort key value": "backend_error.invalid_sort_key_value",
  "description has reach max limit character":
    "backend_error.description_has_reach_max_limit_character",
  "request data contain invalid id industry":
    "backend_error.request_data_contain_invalid_id_industry",
  "requested manager is not member from this bu":
    "backend_error.requested_manager_is_not_member_from_this_bu",
  "invalid id corp": "backend_error.invalid_id_corp",
  "please use correct email/password":
    "backend_error.please_use_correct_email_password",
  "data already exists": "backend_error.data_already_exists",
  "user already exists": "backend_error.user_already_exists",
  "your account has been blocked for 24 hours":
    "backend_error.your_account_has_been_blocked_for_24_hours",
  "password cannot be empty": "backend_error.password_cannot_be_empty",
  "refresh token was expired": "backend_error.refresh_token_was_expired",
  "full name cannot be empty": "backend_error.full_name_cannot_be_empty",
  "full name has reach max limit character":
    "backend_error.full_name_has_reach_max_limit_character",
  "image is required": "backend_error.image_is_required",
  "invalid id bu": "backend_error.invalid_id_bu",
  "id business unit cannot be empty":
    "backend_error.id_business_unit_cannot_be_empty",
  "id corporation cannot be empty":
    "backend_error.id_corporation_cannot_be_empty",
  "gender cannot be empty": "backend_error.gender_cannot_be_empty",
  "gender only allow for male or female":
    "backend_error.gender_only_allow_for_male_or_female",
  "dob cannot be empty": "backend_error.dob_cannot_be_empty",
  "full name only can contain alphanumeric with space":
    "backend_error.full_name_only_can_contain_alphanumeric_with_space",
  "preferred name only can contain alphanumeric with space":
    "backend_error.preferred_name_only_can_contain_alphanumeric_with_space",
  "preferred name has reach max limit character":
    "backend_error.preferred_name_has_reach_max_limit_character",
  "maximum email is 100 char": "backend_error.maximum_email_is_100_char",
  "dob format must be yyyy-mm-dd":
    "backend_error.dob_format_must_be_yyyy_mm_dd",
  "desired start date format must be yyyy-mm-dd":
    "backend_error.desired_start_date_format_must_be_yyyy_mm_dd",
  "joining date format must be yyyy-mm-dd":
    "backend_error.joining_date_format_must_be_yyyy_mm_dd",
  "paid base date format must be yyyy-mm-dd":
    "backend_error.paid_base_date_format_must_be_yyyy_mm_dd",
  "invalid value of sort key": "backend_error.invalid_value_of_sort_key",
  "invalid value of sort type": "backend_error.invalid_value_of_sort_type",
  "refresh token cannot be empty":
    "backend_error.refresh_token_cannot_be_empty",
  "this user already have default address":
    "backend_error.this_user_already_have_default_address",
  "password contains invalid character":
    "backend_error.password_contains_invalid_character",
  "blacklisting a user require reason":
    "backend_error.blacklisting_a_user_require_reason",
  "address must have at least 1 default":
    "backend_error.address_must_have_at_least_1_default",
  "value must be between 0-5 and with multiple of .5":
    "backend_error.value_must_be_between_0_5_and_with_multiple_of_5",
  "student id is required": "backend_error.student_id_is_required",
  "expected graduation date is required":
    "backend_error.expected_graduation_date_is_required",
  "expected graduation date is invalid":
    "backend_error.expected_graduation_date_is_invalid",
  "file cannot be empty": "backend_error.file_cannot_be_empty",
  "resignation date is invalid, it must be greater than the joining date":
    "backend_error.resignation_date_is_invalid_it_must_be_greater_than_the_joining_date",
  "invalid application medium": "backend_error.invalid_application_medium",
  "nationality has reach max limit character":
    "backend_error.nationality_has_reach_max_limit_character",
  "invalid isd code format": "backend_error.invalid_isd_code_format",
  "invalid phone number format": "backend_error.invalid_phone_number_format",
  "maturity previous format must be yyyy-mm-dd":
    "backend_error.maturity_previous_format_must_be_yyyy_mm_dd",
  "enrollment date format must be yyyy-mm-dd":
    "backend_error.enrollment_date_format_must_be_yyyy_mm_dd",
  "maturity individual contract format must be yyyy-mm-dd":
    "backend_error.maturity_individual_contract_format_must_be_yyyy_mm_dd",
  "date join format must be yyyy-mm-dd":
    "backend_error.date_join_format_must_be_yyyy_mm_dd",
  "invalid employment type value":
    "backend_error.invalid_employment_type_value",
  "invalid value for field: 'department'":
    "backend_error.invalid_value_for_field_department",
  "invalid value for field: 'name'":
    "backend_error.invalid_value_for_field_name",
  "invalid value for field: 'keyword'":
    "backend_error.invalid_value_for_field_keyword",
  "invalid value for field: 'post'":
    "backend_error.invalid_value_for_field_post",
  "invalid value for field: 'name_en'":
    "backend_error.invalid_value_for_field_name_en",
  "invalid value for field: 'name_ja'":
    "backend_error.invalid_value_for_field_name_ja",
  "invalid value for field: 'x-lang'":
    "backend_error.invalid_value_for_field_x_lang",
  "invalid value for field: 'payment_type'":
    "backend_error.invalid_value_for_field_payment_type",
  "invalid value for field: 'payment_method_destination'":
    "backend_error.invalid_value_for_field_payment_method_destination",
  "invalid value for field: 'payment_method_destinationarea'":
    "backend_error.invalid_value_for_field_payment_method_destination_area",
  "invalid value for field: 'branch_office'":
    "backend_error.invalid_value_for_field_branch_office",
  "invalid value for field: 'id'": "backend_error.invalid_value_for_field_id",
  "invalid value for field: 'blacklist_reason'":
    "backend_error.invalid_value_for_field_blacklist_reason",
  "invalid value for field: 'x-id-user'":
    "backend_error.invalid_value_for_field_x_id_user",
  "invalid value for field: 'job_title'":
    "backend_error.invalid_value_for_field_job_title",
  "invalid value for field: 'employment_type'":
    "backend_error.invalid_value_for_field_employment_type",
  "invalid value for field: 'company_name'":
    "backend_error.invalid_value_for_field_company_name",
  "invalid value for field: 'work_location'":
    "backend_error.invalid_value_for_field_work_location",
  "invalid value for field: 'type_of_work'":
    "backend_error.invalid_value_for_field_type_of_work",
  "invalid value for field: 'indeed_job_title'":
    "backend_error.invalid_value_for_field_occupation",
  "invalid value for field: 'occupation'":
    "backend_error.invalid_value_for_field_occupation",
  "invalid value for field: 'joining_date'":
    "backend_error.invalid_value_for_field_joining_date",
  "invalid value for field: 'resignation_date'":
    "backend_error.invalid_value_for_field_resignation_date",
  "invalid value for field: 'is_currently_working'":
    "backend_error.invalid_value_for_field_is_currently_working",
  "invalid value for field: 'application_mediums'":
    "backend_error.invalid_value_for_field_application_mediums",
  "invalid value for field: 'id_business_unit'":
    "backend_error.invalid_value_for_field_id_business_unit",
  "invalid value for field: 'id_corporation'":
    "backend_error.invalid_value_for_field_id_corporation",
  "invalid value for field: 'full_name'":
    "backend_error.invalid_value_for_field_full_name",
  "invalid value for field: 'preferred_name'":
    "backend_error.invalid_value_for_field_preferred_name",
  "invalid value for field: 'nationality'":
    "backend_error.invalid_value_for_field_nationality",
  "invalid value for field: 'email'":
    "backend_error.invalid_value_for_field_email",
  "invalid value for field: 'phone_number'":
    "backend_error.invalid_value_for_field_phone_number",
  "invalid value for field: 'gender'":
    "backend_error.invalid_value_for_field_gender",
  "invalid value for field: 'date_of_birth'":
    "backend_error.invalid_value_for_field_date_of_birth",
  "invalid value for field: 'position'":
    "backend_error.invalid_value_for_field_position",
  "invalid value for field: 'affiliated_branch'":
    "backend_error.invalid_value_for_field_affiliated_branch",
  "invalid value for field: 'past_affiliation'":
    "backend_error.invalid_value_for_field_past_affiliation",
  "invalid value for field: 'paid_base_date'":
    "backend_error.invalid_value_for_field_paid_base_date",
  "invalid value for field: 'x-id-corp'":
    "backend_error.invalid_value_for_field_x_id_corp",
  "invalid value for field: 'x-id-bu'":
    "backend_error.invalid_value_for_field_x_id_bu",
  "invalid value for field: 'description'":
    "backend_error.invalid_value_for_field_description",
  "invalid value for field: 'establishment_date'":
    "backend_error.invalid_value_for_field_establishment_date",
  "invalid value for field: 'invoice_eligible_business'":
    "backend_error.invalid_value_for_field_invoice_eligible_business",
  "invalid value for field: 'id_job_listing'":
    "backend_error.invalid_value_for_field_id_job_listing",
  "invalid value for field: 'substraction'":
    "backend_error.invalid_value_for_field_substraction",
  "invalid value for field: 'page'":
    "backend_error.invalid_value_for_field_page",
  "invalid value for field: 'page-size'":
    "backend_error.invalid_value_for_field_page_size",
  "invalid value for field: 'sort_key'":
    "backend_error.invalid_value_for_field_sort_key",
  "invalid value for field: 'sort_type'":
    "backend_error.invalid_value_for_field_sort_type",
  "invalid value for field: 'start_creation_date'":
    "backend_error.invalid_value_for_field_start_creation_date",
  "invalid value for field: 'end_creation_date'":
    "backend_error.invalid_value_for_field_end_creation_date",
  "invalid value for field: 'remaining_slot'":
    "backend_error.invalid_value_for_field_remaining_slot",
  "invalid value for field: 'id_organization_chief'":
    "backend_error.invalid_value_for_field_id_organization_chief",
  "invalid value for field: 'id_commander'":
    "backend_error.invalid_value_for_field_id_commander",
  "invalid value for field: 'id_pic_corporation'":
    "backend_error.invalid_value_for_field_id_pic_corporation",
  "invalid value for field: 'id_corporation_complain_officer'":
    "backend_error.invalid_value_for_field_id_corporation_complain_officer",
  "invalid value for field: 'conflict_date'":
    "backend_error.invalid_value_for_field_conflict_date",
  "invalid value for field: 'id_user_client'":
    "backend_error.invalid_value_for_field_id_user_client",
  "invalid value for field: 'date_of_joining'":
    "backend_error.invalid_value_for_field_date_of_joining",
  "invalid value for field: 'org_based_restriction_date'":
    "backend_error.invalid_value_for_field_org_based_restriction_date",
  "invalid value for field: 'skill_experience_factor'":
    "backend_error.invalid_value_for_field_skill_experience_factor",
  "invalid value for field: 'paid_leave_date'":
    "backend_error.invalid_value_for_field_paid_leave_date",
  "invalid value for field: 'next_paid_leave_date'":
    "backend_error.invalid_value_for_field_next_paid_leave_date",
  "invalid value for field: 'id_staff_status'":
    "backend_error.invalid_value_for_field_id_staff_status",
  "leave action is not allowed due to no other member is holding access 'edit the permissions related to other members' company information management.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_edit_the_permissions_related_to_other_members_company_information_management",
  "leave action is not allowed due to no other member is holding access 'create, read, edit, delete company information.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_create_read_edit_delete_company_information",
  "leave action is not allowed due to no other member is holding access 'delete corporate account.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_delete_corporate_account",
  "leave action is not allowed due to no other member is holding access 'can edit permissions related to member management of other company members.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_can_edit_permissions_related_to_member_management_of_other_company_members",
  "leave action is not allowed due to no other member is holding access 'edit corporation members' role names.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_edit_corporation_members_role_names",
  "leave action is not allowed due to no other member is holding access 'invite corporation members.'":
    "backend_error.leave_action_is_not_allowed_due_to_no_other_member_is_holding_access_invite_corporation_members",
  "one or more of these access 'can edit permissions related to member management of other bu members' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_can_edit_permissions_related_to_member_management_of_other_bu_members_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "one or more of these access 'edit bu members' role names' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_edit_bu_members_role_names_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "one or more of these access 'add or create bu members' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_add_or_create_bu_members_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "one or more of these access 'edit the permissions related to the general settings of other members' bus.' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_edit_the_permissions_related_to_the_general_settings_of_other_members_bus_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "one or more of these access 'edit general settings of bu' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_edit_general_settings_of_bu_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "one or more of these access 'edit permissions related to app management for other members' cannot be revoked due to no other member is holding access":
    "backend_error.one_or_more_of_these_access_edit_permissions_related_to_app_management_for_other_members_cannot_be_revoked_due_to_no_other_member_is_holding_access",
  "member cannot be removed due to no other member is holding access 'can edit permissions related to member management of other bu members'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_can_edit_permissions_related_to_member_management_of_other_bu_members",
  "member cannot be removed due to no other member is holding access 'edit bu members' role names'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_edit_bu_members_role_names",
  "member cannot be removed due to no other member is holding access 'add or create bu members'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_add_or_create_bu_members",
  "member cannot be removed due to no other member is holding access 'edit the permissions related to the general settings of other members' bus.'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_edit_the_permissions_related_to_the_general_settings_of_other_members_bus",
  "member cannot be removed due to no other member is holding access 'edit general settings of bu'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_edit_general_settings_of_bu",
  "member cannot be removed due to no other member is holding access 'edit permissions related to app management for other members'":
    "backend_error.member_cannot_be_removed_due_to_no_other_member_is_holding_access_edit_permissions_related_to_app_management_for_other_members",
  "access validation error for field: 'member-manager' (required_access=1)":
    "backend_error.access_validation_error_for_field_member_manager_required_access_1",
  "access validation error for field: 'list_access' (required_access=7)":
    "backend_error.access_validation_error_for_field_list_access_required_access_7",
  "access validation error for field: 'role_name' (required_access=8)":
    "backend_error.access_validation_error_for_field_role_name_required_access_8",
  "leave action cannot be performed as the user has access rights that have not been assigned to any other user":
    "backend_error.access_right.required_hold_by_user",
  "cannot add this retirment payment data":
    "retirement_payment_history.add.failed.duplicate",
};
